function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, watch } from "vue";
import { definePropType } from "@types-vue/props";
import { Message } from "element-ui";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        schema: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        },
        submitFn: {
            type: definePropType(Function),
            required: true
        },
        rules: {
            type: definePropType(Object)
        }
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var loading = ref(false);
        var formRef = ref();
        var disabled = computed(function() {
            if (!props.rules) return false;
            return !Object.entries(props.rules).every(function(param) {
                var _param = _slicedToArray(param, 2), ruleObj = _param[0], rule = _param[1];
                return rule.check(props.model[ruleObj]);
            });
        });
        var handleClose = function() {
            if (!loading.value) {
                emit("update:visible", false);
            }
        };
        var handleSubmit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _$ref, result;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate();
                        case 3:
                            result = _ctx.sent;
                            if (result) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            loading.value = true;
                            _ctx.prev = 7;
                            _ctx.next = 10;
                            return props.submitFn();
                        case 10:
                            Message.success("\u64CD\u4F5C\u6210\u529F");
                            loading.value = false;
                            emit("handleRefresh");
                            handleClose();
                            _ctx.next = 20;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](7);
                            Message.success("\u64CD\u4F5C\u5931\u8D25");
                            loading.value = false;
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        7,
                        16
                    ]
                ]);
            }));
            return function handleSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return props.visible;
        }, function(val) {
            if (!val) {
                var _$ref;
                (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            }
        });
        return {
            loading: loading,
            formRef: formRef,
            disabled: disabled,
            handleClose: handleClose,
            handleSubmit: handleSubmit
        };
    }
});
